((Drupal, $, drupalSettings) => {
  Drupal.behaviors.seAnnotations = {
    counter: 1,

    attach(context) {
      const saveButton = $(".annotations__sidebar__save", context);
      const annotationsAnswer = $(".annotations__answer", context);

      // Load existing annotations
      this.loadExistingAnnotations();

      // Highlight on mouse up
      annotationsAnswer.on("mouseup", () => {
        const selection = window.getSelection();

        // Prevent triggering if there is no text selected
        if (!selection || !selection.toString().trim()) {
          return;
        }

        // Ensure the selection is inside a <p> element within .annotations__answer
        const range = selection.getRangeAt(0);
        const container = range.commonAncestorContainer;
        const isInsideParagraph = $(container).closest("p").length > 0;

        if (!isInsideParagraph) {
          return;
        }

        this.handleHighlight();
      });

      // Remove annotation
      $("body", context)
        .once("remove-annotation")
        .on("click", ".annotations__sidebar__annotation__remove", (e) => {
          e.preventDefault();
          this.removeAnnotation($(e.currentTarget));
        });

      // Save annotations
      saveButton.on("click", () => this.saveAnnotations());

      // Enable score input
      $(".annotations__review_score", context).on("click", () => {
        $("input[name=score]", context).attr("disabled", false).focus();
      });

      // Hover functions
      $("body", context).on(
        {
          mouseenter: (e) => this.toggleAnnotationHover(e, true),
          mouseleave: (e) => this.toggleAnnotationHover(e, false),
        },
        ".annotations__sidebar__annotation"
      );

      // Close modal using delegated event listener
      $("body").on("click", ".annotations__close-modal", (e) => {
        e.preventDefault();

        const $dialog = $(".ui-dialog--annotations");
        if ($dialog.length > 0) {
          $dialog.remove();
        }
      });

      // Manually handle the click on .annotations__sidebar__save to ensure scroll styles are reset
      $(document).on("click", ".annotations__sidebar__save", () => {
        if ($("html").hasClass("dialog-open")) {
          $("html").removeClass("dialog-open");
          $("html").removeAttr("style");
          $("body").removeAttr("style");
        }
      });
    },

    loadExistingAnnotations() {
      const { plumeQuiz } = drupalSettings;

      if (plumeQuiz?.editorPopup?.existingAnnotations) {
        const existingAnnotations = JSON.parse(
          plumeQuiz.editorPopup.existingAnnotations
        );

        if (existingAnnotations) {
          $(".annotations__answer").html(
            existingAnnotations.answerWithAnnotations
          );
          existingAnnotations.list.forEach((annotation, index) => {
            if ($(`[data-annotation-id="${index + 1}"]`).length === 0) {
              this.addAnnotation(annotation.id, annotation.teacherAnnotation);
            }
          });
          this.counter = existingAnnotations.list.length + 1;
        }
      }

      if (plumeQuiz?.annotationsData) {
        Object.entries(plumeQuiz.annotationsData).forEach(
          ([id, dataString]) => {
            const data = JSON.parse(dataString);
            $(`.quiz-result-answer__essay--${id}`)
              .empty()
              .append(data.answerWithAnnotations);
            data.list.forEach((annotation) => {
              this.addAnnotation(
                annotation.id,
                annotation.teacherAnnotation,
                $(`.essay-feedback--${id}`)
              );
            });
          }
        );
      }
    },

    handleHighlight() {
      const selection = window.getSelection();
      if (!selection.toString()) return;

      const range = selection.getRangeAt(0);
      const highlightSpan = document.createElement("span");

      highlightSpan.setAttribute("id", `annotation-badge-${this.counter}`);
      highlightSpan.setAttribute("data-id", this.counter);
      highlightSpan.classList.add(
        `annotation-badge-${this.counter}`,
        "annotations__answer__annotation"
      );
      highlightSpan.appendChild(range.extractContents());
      range.insertNode(highlightSpan);

      this.addAnnotation(this.counter);
      this.counter += 1;
    },

    saveAnnotations() {
      const annotations = {
        answerWithAnnotations: $(".annotations__answer").html(),
        list: [],
      };

      $(".annotations__sidebar__annotation").each((_, element) => {
        const $element = $(element);
        annotations.list.push({
          id: $element.attr("data-annotation-id"),
          teacherAnnotation: $element.find("textarea").val(),
        });
      });

      const saveUrl = drupalSettings.plumeQuiz.editorPopup.saveUrl;
      $.post(saveUrl, JSON.stringify(annotations), () =>
        $(".ui-dialog--annotations").remove()
      );
    },

    removeAnnotation($button) {
      const $annotation = $button.closest(".annotations__sidebar__annotation");
      const id = parseInt($annotation.attr("data-annotation-id"), 10);

      $annotation.remove();
      $(`.annotation-badge-${id}`).contents().unwrap();
      this.updateAnnotationsAfterRemoval(id);
      this.counter -= 1;
    },

    updateAnnotationsAfterRemoval(id) {
      $(".annotations__answer__annotation").each((_, element) => {
        const $element = $(element);
        const currentId = parseInt($element.attr("data-id"), 10);
        if (currentId > id) {
          $element
            .attr("data-id", currentId - 1)
            .attr("id", `annotation-badge-${currentId - 1}`)
            .removeClass(`annotation-badge-${currentId}`)
            .addClass(`annotation-badge-${currentId - 1}`);
        }
      });

      $(".annotations__sidebar__annotation").each((_, element) => {
        const $element = $(element);
        const currentId = parseInt($element.attr("data-annotation-id"), 10);
        if (currentId > id) {
          $element.attr("data-annotation-id", currentId - 1);
          $element
            .find(".annotations__sidebar__annotation__badge")
            .text(currentId - 1);
        }
      });
    },

    toggleAnnotationHover(event, isHover) {
      const $element = $(event.currentTarget);
      const id = $element.attr("data-annotation-id");
      $(`.annotations__answer__annotation[data-id="${id}"]`).toggleClass(
        "hover",
        isHover
      );
    },

    addAnnotation(id, value = "", $studentView) {
      const markup = `
        <div class="annotations__sidebar__annotation" data-annotation-id="${id}">
          <span class="annotations__sidebar__annotation__badge">${id}</span>
          ${
            $studentView
              ? `<p class="annotations__sidebar__annotation__input">${value}</p>`
              : `<textarea class="annotations__sidebar__annotation__input">${value}</textarea>`
          }
          ${
            $studentView
              ? ""
              : `<button class="annotations__sidebar__annotation__remove btn btn-primary btn-tier-colored">X</button>`
          }
        </div>
      `;

      if ($studentView) {
        $studentView.append(markup);
      } else {
        $(".annotations__sidebar").append(markup);
        $(`[data-annotation-id="${id}"] textarea`).focus();
      }
    },
  };
})(Drupal, jQuery, drupalSettings);
